<div class="container">
  <div
    class="sidebar"
    app-sidebar
  ></div>
  <div
    class="main-section"
    app-content
  >
    <router-outlet></router-outlet>
  </div>
</div>
